/**
 * 观心亭:孩子自己做的性格小镜子
 *
 * 参照 MBTI 的四组倾向自己写的原创问法(没有用官方或网上流传的题,
 * 那些有版权,而且是写给大人的)。每组 5 问,二选一,奇数问不会打平。
 * 结果只说「现在更偏哪一边」,不贴死标签;只存在本机浏览器,不上传。
 */

// 四组倾向:左边一极 / 右边一极,用孩子听得懂的话
export const AXES = [
  { id: 'EI', left: { code: 'E', name: '热闹充电' }, right: { code: 'I', name: '安静充电' } },
  { id: 'SN', left: { code: 'S', name: '看重实际' }, right: { code: 'N', name: '爱想新点子' } },
  { id: 'TF', left: { code: 'T', name: '讲道理' }, right: { code: 'F', name: '顾感受' } },
  { id: 'JP', left: { code: 'J', name: '爱计划' }, right: { code: 'P', name: '随机应变' } },
];

// 每问两个选项 [文字, 极];两边轮流放在前面,免得孩子一路点第一个也成一个类型
const q = (axis, text, a, b) => ({ axis, text, options: [a, b] });

const QUESTIONS_6_8 = [
  q('EI', '下课了,你最想……', ['和小伙伴一起玩', 'E'], ['自己玩一会儿', 'I']),
  q('SN', '听故事,你更喜欢……', ['会魔法的神奇故事', 'N'], ['真的发生过的事', 'S']),
  q('TF', '小伙伴哭了,你会先……', ['问问出了什么事,帮他想办法', 'T'], ['抱抱他,陪着他', 'F']),
  q('JP', '玩具玩完了,你会……', ['等一会儿再收', 'P'], ['马上收好', 'J']),
  q('EI', '班里来了新同学,你会……', ['等他来找我玩', 'I'], ['主动去打招呼', 'E']),
  q('SN', '画画的时候,你喜欢画……', ['看见过的东西', 'S'], ['脑子里想出来的东西', 'N']),
  q('TF', '分糖果的时候,你觉得……', ['给最想要的人多一点', 'F'], ['每人一样多最公平', 'T']),
  q('JP', '出去玩之前,你喜欢……', ['先想好玩什么', 'J'], ['到了再说', 'P']),
  q('EI', '有开心的事,你会……', ['马上告诉大家', 'E'], ['自己偷偷乐一会儿', 'I']),
  q('SN', '玩积木,你喜欢……', ['拼自己想的样子', 'N'], ['照着图一步步拼', 'S']),
  q('TF', '好朋友的画不太好看,你会……', ['告诉他哪里可以改', 'T'], ['先夸夸他', 'F']),
  q('JP', '做手工的时候,你……', ['想到哪做到哪', 'P'], ['做完一件再做下一件', 'J']),
  q('EI', '过生日,你想……', ['和家人、一两个好朋友一起', 'I'], ['请好多小朋友来', 'E']),
  q('SN', '散步的时候,你常常……', ['看路边的花和小虫', 'S'], ['想天上的云像什么', 'N']),
  q('TF', '玩游戏输了,你会……', ['有点难过,想要人安慰', 'F'], ['想想为什么输了', 'T']),
  q('JP', '本来说好去公园,突然不去了,你……', ['有点不高兴', 'J'], ['没关系,玩别的也行', 'P']),
  q('EI', '玩累了,你想……', ['换个游戏接着热闹', 'E'], ['安安静静歇一会儿', 'I']),
  q('SN', '学新东西,你更想先知道……', ['为什么会这样', 'N'], ['怎么做', 'S']),
  q('TF', '你更喜欢别人说你……', ['真善良', 'F'], ['真聪明', 'T']),
  q('JP', '放学回家,你……', ['先玩,再写作业', 'P'], ['先写作业,再玩', 'J']),
];

const QUESTIONS_9_12 = [
  q('EI', '放学后,你更想……', ['约朋友一起玩', 'E'], ['自己安静待一会儿', 'I']),
  q('SN', '读故事,你更喜欢……', ['充满想象的奇幻故事', 'N'], ['真实发生过的事', 'S']),
  q('TF', '朋友考砸了很难过,你会先……', ['帮他看看哪里没做好', 'T'], ['陪着他、安慰他', 'F']),
  q('JP', '离交作业还有好几天,你会……', ['等快到时间再做', 'P'], ['先做完,心里踏实', 'J']),
  q('EI', '到了一个新班级,你通常……', ['先观察,慢慢熟悉', 'I'], ['很快就主动和人聊天', 'E']),
  q('SN', '老师讲新知识,你更想先知道……', ['具体怎么做', 'S'], ['为什么会这样', 'N']),
  q('TF', '做决定的时候,你更看重……', ['大家会不会开心', 'F'], ['怎样做最合理', 'T']),
  q('JP', '出去玩之前,你喜欢……', ['提前想好去哪、做什么', 'J'], ['到了再说,随便逛逛', 'P']),
  q('EI', '有了开心的事,你最先想……', ['马上讲给别人听', 'E'], ['先自己在心里高兴一会儿', 'I']),
  q('SN', '做手工的时候,你通常……', ['自己想一个新造型', 'N'], ['照着说明一步步做', 'S']),
  q('TF', '玩游戏有人不守规则,你会……', ['直接说规则不是这样', 'T'], ['怕场面尴尬,先算了', 'F']),
  q('JP', '你的书桌通常……', ['有点乱,但自己找得到', 'P'], ['东西放得整整齐齐', 'J']),
  q('EI', '小组讨论时,你更常……', ['想好了再开口', 'I'], ['边说边想', 'E']),
  q('SN', '你更容易注意到……', ['身边的小细节,比如谁换了新文具', 'S'], ['脑子里冒出来的新点子', 'N']),
  q('TF', '两个好朋友吵架了,你会……', ['想办法让他们和好', 'F'], ['听听两边,看谁更有道理', 'T']),
  q('JP', '计划突然变了,你会……', ['有点不舒服,原来都想好了', 'J'], ['没关系,换个玩法也不错', 'P']),
  q('EI', '理想的周末是……', ['和很多人一起出去玩', 'E'], ['在家做自己喜欢的事', 'I']),
  q('SN', '别人说起你,更像会说……', ['爱幻想、点子多', 'N'], ['踏实、靠得住', 'S']),
  q('TF', '被人夸,你更喜欢听到……', ['你对人真好', 'F'], ['你想得真清楚', 'T']),
  q('JP', '做一件大事(比如准备表演),你会……', ['边做边调整', 'P'], ['先列好步骤再开始', 'J']),
];

export function questionsFor(ageBand) {
  return ageBand === '6-8' ? QUESTIONS_6_8 : QUESTIONS_9_12;
}

// 16 种类型配华夏风的称号;长处和「可以多练的地方」都用正面的口吻
export const TYPES = {
  INTJ: { title: '谋士', emoji: '🦉', line: '心里有张大地图,喜欢把事情想透再动手。', strengths: ['想得远,能看出事情接下来会怎样', '自己定了目标就能坚持', '遇到难题会自己琢磨办法'], grow: ['试着多听听别人的想法', '偶尔也让自己随性玩一玩'] },
  INTP: { title: '格物先生', emoji: '🔭', line: '对什么都好奇,最爱追问「为什么」。', strengths: ['好奇心强,爱钻研', '想问题有自己的角度', '能发现别人没注意到的规律'], grow: ['想到的点子,试着动手做完', '说话时也照顾一下别人的心情'] },
  ENTJ: { title: '统帅', emoji: '🏯', line: '天生会带队,喜欢把事情安排得明明白白。', strengths: ['有主意,敢拿主意', '做事有条理、效率高', '能带着大家一起完成目标'], grow: ['让别人也有机会出主意', '慢一点,留意伙伴的感受'] },
  ENTP: { title: '纵横家', emoji: '💡', line: '点子一个接一个,最爱讨论和挑战新问题。', strengths: ['反应快,点子多', '敢尝试新方法', '会说话,能把人说服'], grow: ['开了头的事情,试着坚持做完', '讨论时别只为了赢'] },
  INFJ: { title: '仁者', emoji: '🕯️', line: '安静又温暖,能看懂别人心里在想什么。', strengths: ['很会体贴别人', '有自己相信的事,做事认真', '想象力丰富'], grow: ['不舒服的时候,说出来也没关系', '别对自己要求太完美'] },
  INFP: { title: '诗人', emoji: '📜', line: '心里装着一个小世界,对美好的东西特别敏感。', strengths: ['善良,真心待人', '想象力和创造力强', '能写、能画,会表达心里的感受'], grow: ['想做的事,给自己定个小计划', '被批评时,记得那不等于你不好'] },
  ENFJ: { title: '夫子', emoji: '🎓', line: '喜欢帮助别人,大家都愿意听你说。', strengths: ['热心,乐于助人', '会鼓励人,让大家团结', '说话有感染力'], grow: ['也要照顾好自己', '不是每个人都开心也没关系'] },
  ENFP: { title: '游侠', emoji: '🪁', line: '热情又爱冒险,走到哪儿都能交到朋友。', strengths: ['热情开朗,朋友多', '想象力丰富,点子新', '对新鲜事充满兴趣'], grow: ['一次专心做好一件事', '答应的事,记得按时做完'] },
  ISTJ: { title: '史官', emoji: '📚', line: '踏实可靠,答应的事一定做到。', strengths: ['认真负责,说到做到', '记性好,注意细节', '做事有条有理'], grow: ['试试新方法,也许有惊喜', '计划变了,也可以放轻松'] },
  ISFJ: { title: '医者', emoji: '🌿', line: '细心又温柔,默默照顾身边的人。', strengths: ['细心体贴,记得别人的喜好', '耐心,做事稳当', '是让人放心的好朋友'], grow: ['想要什么,可以大方说出来', '偶尔也试试没做过的事'] },
  ESTJ: { title: '县令', emoji: '⚖️', line: '讲规矩、有办法,能把一群人管得井井有条。', strengths: ['做事果断,有条理', '守规则,讲公平', '能组织大家把事办成'], grow: ['听听不一样的做法', '说话时语气可以再柔和一点'] },
  ESFJ: { title: '东道主', emoji: '🍵', line: '热情好客,让身边每个人都觉得舒服。', strengths: ['关心别人,人缘好', '乐于合作,是团队的黏合剂', '做事细致周到'], grow: ['别太在意别人怎么看你', '有不同意见时也可以说出来'] },
  ISTP: { title: '巧匠', emoji: '🔧', line: '动手能力强,喜欢拆拆装装弄明白东西怎么运作。', strengths: ['动手能力强', '遇事冷静,会想办法', '学东西上手快'], grow: ['有心事时,试着跟人说说', '提前想一想,别总是最后一刻'] },
  ISFP: { title: '画师', emoji: '🎨', line: '安静又有艺术感,用自己的方式表达美。', strengths: ['审美好,有艺术感', '温和善良,不爱争', '活在当下,会享受小美好'], grow: ['想法可以更大胆地说出来', '给自己定个小目标试试'] },
  ESTP: { title: '镖师', emoji: '🐎', line: '胆子大、行动快,哪里热闹哪里就有你。', strengths: ['勇敢,敢尝试', '反应快,随机应变', '运动和动手都很在行'], grow: ['做之前先停一下想一想', '坐下来专心的时候多一点'] },
  ESFP: { title: '说书人', emoji: '🎭', line: '开朗爱笑,是大家的开心果。', strengths: ['开朗乐观,带给大家快乐', '会表演、会表达', '对人热情,容易交朋友'], grow: ['重要的事情先做完再玩', '难的事情也坚持一下'] },
};

/** answers: 每问选中的极,如 ['E','N',…];全部答完才算 */
export function scoreAnswers(answers) {
  const counts = {};
  answers.forEach((pole) => {
    counts[pole] = (counts[pole] || 0) + 1;
  });
  const axes = AXES.map(({ id, left, right }) => {
    const l = counts[left.code] || 0;
    const r = counts[right.code] || 0;
    const total = l + r || 1;
    const winner = l >= r ? left : right;
    return { id, left, right, winner: winner.code, percent: Math.round((Math.max(l, r) / total) * 100), leftPercent: Math.round((l / total) * 100) };
  });
  return { code: axes.map((a) => a.winner).join(''), axes };
}

// 本机存档:{ [存档 key]: { code, axes, at } },一台设备上几个孩子各存各的
export const STORAGE_KEY = 'huaxia_guanxin';
